/**
 * 점검 화면 컴포넌트
 * 점검 중일 때 협력사에게 표시되는 화면
 */
import React from 'react';
import { GetActiveMaintenanceResponseDto } from '../types/maintenance.types';
import { format } from 'date-fns';
import '../styles/MaintenanceScreen.css';

interface MaintenanceScreenProps {
    maintenance: GetActiveMaintenanceResponseDto;
}

export const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({ maintenance }) => {
    const formatDateTime = (dateValue: string | number[] | null) => {
        if (!dateValue) return '-';
        try {
            // 배열 형식: [2026, 1, 6, 14, 0, 0] (LocalDateTime 직렬화)
            if (Array.isArray(dateValue)) {
                const [year, month, day, hour = 0, minute = 0] = dateValue;
                const date = new Date(year, month - 1, day, hour, minute);
                return format(date, 'yyyy년 MM월 dd일 HH:mm');
            }
            return format(new Date(dateValue), 'yyyy년 MM월 dd일 HH:mm');
        } catch {
            return String(dateValue);
        }
    };

    return (
        <div className="maintenance-screen">
            <div className="maintenance-content">
                <div className="maintenance-icon">
                    <i className="fas fa-tools"></i>
                </div>
                <h1 className="maintenance-title">시스템 점검 중</h1>
                <p className="maintenance-message">
                    {maintenance.msgContent || '서비스 점검 중입니다. 잠시 후 다시 이용해주세요.'}
                </p>
                <div className="maintenance-schedule">
                    <div className="schedule-item">
                        <span className="schedule-label">점검 시작</span>
                        <span className="schedule-value">{formatDateTime(maintenance.startDate)}</span>
                    </div>
                    <div className="schedule-item">
                        <span className="schedule-label">점검 종료 예정</span>
                        <span className="schedule-value">{formatDateTime(maintenance.endDate)}</span>
                    </div>
                </div>
                <p className="maintenance-notice">
                    점검 시간은 상황에 따라 변경될 수 있습니다.<br />
                    이용에 불편을 드려 죄송합니다.
                </p>
            </div>
        </div>
    );
};

export default MaintenanceScreen;
